import { render, staticRenderFns } from "./ErrorHandler.vue?vue&type=template&id=5cd63b18&scoped=true"
import script from "./ErrorHandler.vue?vue&type=script&lang=ts"
export * from "./ErrorHandler.vue?vue&type=script&lang=ts"
import style0 from "./ErrorHandler.vue?vue&type=style&index=0&id=5cd63b18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd63b18",
  null
  
)

export default component.exports